import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { shareReplay } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { ValidationsExportsResource } from '../../account/resources/validationsExports.resource';
import { AppState } from '../../store';
import { updateValidators } from './store/validators.actions';

@Injectable({
  providedIn: 'root',
})
export class ValidationExportsService {
  private subscribeCall = this.validationsExportResource.get().pipe(shareReplay(1));

  constructor(private validationsExportResource: ValidationsExportsResource, private store: Store<AppState>) {}

  public loadValidations(): Promise<any> {
    this.subscribeCall.subscribe(
      (validators) => {
        this.store.dispatch(updateValidators({ validators }));
      },
      function () {
        console.error('Validations export failed!!');
      },
    );
    return this.subscribeCall.toPromise();
  }
}

((window as any).xplenty as angular.IModule).service(
  'validationExportsService',
  downgradeInjectable(ValidationExportsService),
);
